import { render, staticRenderFns } from "./UnlockList.vue?vue&type=template&id=54321e2a&scoped=true&"
import script from "./UnlockList.vue?vue&type=script&lang=js&"
export * from "./UnlockList.vue?vue&type=script&lang=js&"
import style0 from "./UnlockList.vue?vue&type=style&index=0&id=54321e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54321e2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54321e2a')) {
      api.createRecord('54321e2a', component.options)
    } else {
      api.reload('54321e2a', component.options)
    }
    module.hot.accept("./UnlockList.vue?vue&type=template&id=54321e2a&scoped=true&", function () {
      api.rerender('54321e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/運勢書2024/UnlockList.vue"
export default component.exports